import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import DayOutputItemForm from 'components/organismos/master/attend/TimeOutputLayout/DayOutputItemForm';

const DayOutputItemPage: React.FC = () => { 
  return (
    <SidebarTemplate>
      <DayOutputItemForm />
    </SidebarTemplate>
  );
};

export default DayOutputItemPage;
